export const DEFAULT_CATEGORY_RULES = {
  laborTaxable: true,
  partsTaxable: true,
  otherTaxable: true
};

export const isCategoryTaxable = (category, taxCategoryRules = DEFAULT_CATEGORY_RULES) => {
  const rules = taxCategoryRules || DEFAULT_CATEGORY_RULES;
  if (category === 'labor') return rules.laborTaxable !== false;
  if (category === 'parts') return rules.partsTaxable !== false;
  return rules.otherTaxable !== false;
};

// A line item's own `taxable` field ('taxable' | 'exempt' | null) overrides
// the category default when set; null defers to isCategoryTaxable.
export const isLineItemTaxable = (item, taxCategoryRules = DEFAULT_CATEGORY_RULES) => {
  if (item?.taxable === 'exempt') return false;
  if (item?.taxable === 'taxable') return true;
  return isCategoryTaxable(item?.category, taxCategoryRules);
};

export const computeTaxableSubtotal = (lineItems = [], taxCategoryRules = DEFAULT_CATEGORY_RULES) =>
  (lineItems || []).reduce((sum, item) => {
    const amount = Number(item.amount ?? (Number(item.unitPrice || 0) * Number(item.quantity || 1))) || 0;
    if (!isLineItemTaxable(item, taxCategoryRules)) return sum;
    return sum + amount;
  }, 0);

export const computeInvoiceTotals = (lineItems, taxContext) => {
  const taxEnabled = taxContext?.taxEnabled !== false;
  const taxRate = Number(taxContext?.taxRate || 0);
  const taxCategoryRules = taxContext?.taxCategoryRules || DEFAULT_CATEGORY_RULES;

  const subtotal = (lineItems || []).reduce((sum, item) => {
    const amount = Number(item.amount ?? (Number(item.unitPrice || 0) * Number(item.quantity || 1))) || 0;
    return sum + amount;
  }, 0);

  const taxableSubtotal = computeTaxableSubtotal(lineItems, taxCategoryRules);
  const taxAmount = taxEnabled ? Math.round(taxableSubtotal * taxRate * 100) / 100 : 0;
  const total = Math.round((subtotal + taxAmount) * 100) / 100;

  return {
    subtotal: Math.round(subtotal * 100) / 100,
    taxAmount,
    total,
    taxableSubtotal: Math.round(taxableSubtotal * 100) / 100
  };
};
